import React from 'react';

import { Flex } from 'src/packages/core';
import { styled, ThemeProvider, useTheme } from 'src/packages/theme';
import { ContainerProps } from './Container.types';

export const StyledContainer = styled((props) => <Flex {...props} />)<ContainerProps>`
  width: 100%;
  margin: 0 auto;
  position: relative;
`;

const Container: React.FC<ContainerProps> = ({
  children,
  paddingX = [4, 4, 8, 25],
  background,
  theme,
  ...rest
}: ContainerProps) => {
  const props = {
    paddingX,
    ...rest,
  };

  const contextTheme = useTheme();

  return (
    <ThemeProvider theme={theme} rtl={contextTheme.rtl}>
      <StyledContainer background={background} {...props}>
        <Flex width='100%' maxWidth='1440px' mx='auto'>
          {children}
        </Flex>
      </StyledContainer>
    </ThemeProvider>
  );
};

export default Container;
